import type { FC } from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { HoverPopover } from "../../shared/HoverPopover";

export type InfoPopoverContent = { title?: string; body?: string; info?: string };
type InfoPopoverProps = InfoPopoverContent & Omit<HoverPopover["popoverProps"], "children">;
export const InfoPopover: FC<InfoPopoverProps> = ({ title, body, info, ...popoverProps }) => {
  return (
    <HoverPopover {...popoverProps}>
      <Stack spacing={1} sx={{ px: 3, py: 2, maxWidth: "20rem" }}>
        {title && (
          <Typography variant="h6" sx={{ lineHeight: 1.25 }}>
            {title}
          </Typography>
        )}

        {body && (
          <Typography
            variant="body2"
            sx={{
              fontSize: theme => theme.typography.pxToRem(12),
              whiteSpace: "pre-wrap",
              textWrap: "balance",
              lineHeight: 1.5,
            }}
          >
            {body}
          </Typography>
        )}
        {info && (
          <Stack
            direction="row"
            sx={{
              border: "1px",
              borderColor: theme => theme.palette.grey["200"],
              bgcolor: theme => theme.palette.grey["100"],
              alignItems: "center",
              padding: 3,
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontSize: theme => theme.typography.pxToRem(12), whiteSpace: "pre-wrap", textWrap: "balance" }}
            >
              {info}
            </Typography>
          </Stack>
        )}
      </Stack>
    </HoverPopover>
  );
};
